import { render, staticRenderFns } from "./AddressDetailForm.vue?vue&type=template&id=22e72f1a&"
import script from "./AddressDetailForm.vue?vue&type=script&lang=js&"
export * from "./AddressDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports